export function request() {
    return {
        type: 'COUNTRY_GET_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'COUNTRY_GET_ERROR',
        errors
    };
}

export function finish(countries) {
    return {
        type: 'COUNTRY_GET_FINISH',
        countries
    };
}
